import { ColumnInfo } from "../../../../models/column-info";
import { UnitWish } from "../../../../models/unit-wish-list";
import { unitBaseTypeEnum } from "../../../../unit-base-type-enum";
import { Part, RefinedParts } from "../../../BuildingConf/models/part";
import { InitialProps } from "../../Common/BuildingInitialPropertiesDialog/init-props";
import { Column, UnitAmount } from "../../models/column";
import { subtypeEnum, variantEnum } from "./column-definition";
import { columnType } from "./column-type.enum";
import { partTypeEnum } from "./part-type.enum";
import { segmentType } from "./segment-type";

export type RowhouseColumn = Column<columnType, segmentType, subtypeEnum, variantEnum>;
export type RowhousePart = Part<RowhouseColumn, partTypeEnum>;
export type RowhouseRefinedParts = RefinedParts<RowhouseColumn, partTypeEnum>;

export const defaultUnitWishList: UnitWish[] =
    [
        {
            type: unitBaseTypeEnum.H_S,
            uiName: 'S',
            percentage: 30,
        },
        {
            type: unitBaseTypeEnum.H_M,
            uiName: 'M',
            percentage: 40,
        },
        {
            type: unitBaseTypeEnum.H_L,
            uiName: 'L',
            percentage: 30,
        }
    ]

export type PropsRowhouse = {
    buildingWidth: number;
    buildingLength: number;
    buildingHeight: number;
    middleFloors: number;
    unitWishList: { type: unitBaseTypeEnum, percentage: number }[];
    totalPercentageH: number;
    amount_H_S_Columns: number;
    amount_H_M1M2_Columns: number;
    amount_H_L_Columns: number;
    parts: RowhousePart[];
    partsRefined: RowhouseRefinedParts[];
    info: ColumnInfo;
    totalAmountOfAllUnits: UnitAmount[];
}


export const getDefaultPropsRowhouse = (initProps: InitialProps): PropsRowhouse => {
    let unitWishList = initProps.unitWishList.length > 0 ? initProps.unitWishList : defaultUnitWishList;
    return {
        buildingWidth: 15,
        buildingLength: 75,
        buildingHeight: 6,
        middleFloors: 2,
        unitWishList,
        totalPercentageH: 100,
        amount_H_S_Columns: 0,
        amount_H_M1M2_Columns: 0,
        amount_H_L_Columns: 0,
        parts: [],
        partsRefined: [],
        info: {
            totalGFA: 0,
            totalUFA: 0,
        },
        totalAmountOfAllUnits: []
    }
}